import React from 'react'
import styled from 'styled-components'

export const StyledComponent = styled(({ isViewAs, src, ...rest }) => <div {...rest} />)`
  display: block;
  width: 25px;
  height: 25px;
  border-radius: 50%;

  background-image: url(${p => p.src});
  background-size: cover;
  background-position: center;

  ${p => p.isViewAs && `
    border: 2px solid #FF7A24;
  `};

  @media (min-width: ${p => p.theme.tabletSize}) {
    width: 40px;
    height: 40px;
  }
`

const _UserAvatar_styled = (props) => <StyledComponent {...props} />
_UserAvatar_styled.propTypes = {}
_UserAvatar_styled.className = StyledComponent

export default _UserAvatar_styled

